<template>
  <div class="not-found">
    <div class="not-found__w">
      <div class="not-found__img-wrp">
        <img
          src="~/assets/icons/incorrect-filter-set.svg"
          alt="incorrect filter set"
          loading="lazy"
        />
      </div>
      <p class="not-found__title">
        {{ _T("@No products matching parameters") }}
      </p>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.not-found {
  width: 100%;

  @include bigMobile {
    padding-inline: 16px;
  }

  &__w {
    width: 100%;

    @include flex-container(column, center, center);
    gap: 24px;

    border-radius: 8px;
    background-color: white;

    padding-block: 16px;
  }

  &__img-wrp {
    @include mobile {
      max-width: 140px;
      width: 100%;
    }
  }

  &__title {
    @include font(18, 24, 700);
    text-align: center;

    letter-spacing: 0.02em;

    @include bigMobile {
      @include font();
    }
  }
}
</style>
